export const INITIAL_COUNTRIES = [
    { code: 'DE', name: 'Allemagne', flag: '🇩🇪', localFlag: '/assets/flags/no_background/DE.png' },
    { code: 'BE', name: 'Belgique', flag: '🇧🇪', localFlag: '/assets/flags/no_background/BE.png' },
    { code: 'ES', name: 'Espagne', flag: '🇪🇸', localFlag: '/assets/flags/no_background/ES.png' },
    { code: 'IT', name: 'Italie', flag: '🇮🇹', localFlag: '/assets/flags/no_background/IT.png' },
    { code: 'PT', name: 'Portugal', flag: '🇵🇹', localFlag: '/assets/flags/no_background/PT.png' },
    { code: 'CH', name: 'Suisse', flag: '🇨🇭', localFlag: '/assets/flags/no_background/CH.png' },
    { code: 'GB', name: 'Royaume-Uni', flag: '🇬🇧', localFlag: '/assets/flags/no_background/GB.png' },
    { code: 'CA', name: 'Canada', flag: '🇨🇦', localFlag: '/assets/flags/no_background/CA.png' },
    { code: 'US', name: 'États-Unis', flag: '🇺🇸', localFlag: '/assets/flags/no_background/US.png' },
    { code: 'AU', name: 'Australie', flag: '🇦🇺', localFlag: '/assets/flags/no_background/AU.png' },
    { code: 'JP', name: 'Japon', flag: '🇯🇵', localFlag: '/assets/flags/no_background/JP.png' },
    { code: 'CN', name: 'Chine', flag: '🇨🇳', localFlag: '/assets/flags/no_background/CN.png' },
    { code: 'KR', name: 'Corée du Sud', flag: '🇰🇷', localFlag: '/assets/flags/no_background/KR.png' },
    { code: 'SG', name: 'Singapour', flag: '🇸🇬', localFlag: '/assets/flags/no_background/SG.png' },
    { code: 'AE', name: 'Émirats Arabes Unis (Dubaï)', flag: '🇦🇪', localFlag: '/assets/flags/no_background/AE.png' },
    { code: 'MA', name: 'Maroc', flag: '🇲🇦', localFlag: '/assets/flags/no_background/MA.png' },
    { code: 'SN', name: 'Sénégal', flag: '🇸🇳', localFlag: '/assets/flags/no_background/SN.png' },
    { code: 'BR', name: 'Brésil', flag: '🇧🇷', localFlag: '/assets/flags/no_background/BR.png' },
    { code: 'MX', name: 'Mexique', flag: '🇲🇽', localFlag: '/assets/flags/no_background/MX.png' },
    { code: 'NZ', name: 'Nouvelle-Zélande', flag: '🇳🇿', localFlag: null },
    { code: 'OTHER', name: 'Autre', flag: '🌍', localFlag: '/assets/flags/no_background/OTHER.png' }
];

export const SECTORS_LIST = [
    "SCIENCES NATURELLES",
    "PRODUCTION INDUSTRIELLE",
    "GESTION DE LA PRODUCTION INDUSTRIELLE",
    "SANTÉ BEAUTÉ PARAMÉDICAL",
    "COMMERCE",
    "INFORMATIQUE SCIENTIFIQUE ET INDUSTRIELLE",
    "CONSTRUCTION",
    "SYSTÈMES D'INFORMATION",
    "ACHATS LOGISTIQUE TRANSPORT",
    "SCIENCES ACADÉMIQUES",
    "AGRICULTURE ET AGROALIMENTAIRE",
    "MARKETING COMMUNICATION",
    "FINANCE COMPTABILITÉ CONTRÔLE BANQUE",
    "RESSOURCES HUMAINES",
    "DROIT ET FISCALITÉ",
    "SERVICES AUX ENTREPRISES",
    "INFORMATION MÉDIAS",
    "SECTEUR PUBLIC"
];
